class HomePageClickTracker {
  constructor(containerSelector = 'body') {
    this.container = document.querySelector(containerSelector);
    this.defaultEvent = 'home_content';
    
    this.init();
  }

  normalizeTrackingValue(value) {
    if (value == null) return null;

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed || trimmed.toLowerCase() === 'null') return null;
      return trimmed;
    }

    return value;
  }

  resolveContentBlock(jsonData, contentId) {
    const rawBlock = this.normalizeTrackingValue(jsonData.block);
    const normalizedBlock = rawBlock
      ? rawBlock.toString().toLowerCase().replace(/[^a-z0-9_]/g, '_')
      : null;
    const normalizedId = contentId
      ? contentId.toString().toLowerCase().replace(/[^a-z0-9_]/g, '_')
      : null;

    const blockMap = {
      image_banner: 'hero_banner',
      ua_content_carousel: 'content_carousel',
      image_with_text: 'promo_banner',
      rich_text: 'editorial_content',
      multicolumn_1: 'content_grid',
      multicolumn_2: 'content_grid',
      dash_social_ugc: 'ugc_carousel',
      '50_50_image_with_text_list': 'promo_banner',
    };

    if (normalizedBlock && blockMap[normalizedBlock]) {
      return blockMap[normalizedBlock];
    }

    if (normalizedId && normalizedId.includes('content_carousel')) {
      return 'content_carousel';
    }

    if (normalizedId && normalizedId.includes('hero_banner')) {
      return 'hero_banner';
    }

    if (normalizedId && normalizedId.includes('multicolumn')) {
      return 'content_grid';
    }

    if (normalizedId && normalizedId.includes('dash_social')) {
      return 'ugc_carousel';
    }

    if (normalizedId && normalizedId.includes('rich_text')) {
      return 'editorial_content';
    }

    return 'promo_banner';
  }

  init() {
    if (!this.container) return;

    this.container.addEventListener('click', (event) => {
      const target = event.target;

      if (target.tagName === "BUTTON") {
        return;
      }

      const trackingScript = this.findTrackingScript(target);

      if (target.tagName === "BUTTON") {
        return;
      }

      if (trackingScript) {
        event.preventDefault();
        event.stopPropagation();
        
        const trackingData = this.extractTrackingData(trackingScript);
        const overrideUrl = this.findClosestUrl(target);

        if (target.hasAttribute('data-tracking-subdetail')) {
          trackingData['content_subdetail'] = this.normalizeTrackingValue(target.getAttribute('data-tracking-subdetail'));
        }

        if (trackingData['content_subdetail'] == null || trackingData['content_subdetail'] === trackingData['content_detail']) {
          delete trackingData['content_subdetail'];
        }
        
        if (overrideUrl) {
          trackingData['content_url'] = overrideUrl;
        }

        if (target.parentElement.classList.contains('slider-button')) {
          trackingData['navigation_element'] = true;
        }

        this.pushToDataLayerAndNavigate(trackingData, overrideUrl, event, target);
      }
    });
  }

  findTrackingScript(el) {
    let element = el;

    while (element && element.tagName !== 'SECTION') {
      element = element.parentElement;
    }

    if (element) {
      const script = element.querySelector('script[id*="tracking-data"]');

      if (script) return script;
    }

    return null;
  }
 
  extractTrackingData(script) {
    if (!script) return null;

    try {
      const jsonData = JSON.parse(script.textContent);

      let contentDetail = this.normalizeTrackingValue(jsonData.detail);
      const contentAltText = this.normalizeTrackingValue(jsonData.alt_text);
      let contentSubdetail = this.normalizeTrackingValue(jsonData.subdetail);
      let contentButtonText = this.normalizeTrackingValue(jsonData.button_text);

      if (contentDetail == null && contentAltText != null) {
        contentDetail = contentAltText;
      }

      const contentId = this.normalizeTrackingValue(jsonData.id);
      const contentTechnicalId = this.normalizeTrackingValue(jsonData.technical_id);
      const contentBlock = this.resolveContentBlock(jsonData, contentId);

      const trackingData = {
        event: this.defaultEvent,
        content_block: contentBlock,
        content_location: jsonData.index != null ? String(jsonData.index) : null,
        content_detail: contentDetail,
        content_url: null,
        content_id: contentId,
        content_technical_id: contentTechnicalId,
      };

      if (contentSubdetail != null && contentSubdetail !== contentDetail) {
        trackingData.content_subdetail = contentSubdetail;
      }

      if (contentButtonText != null) {
        trackingData.content_button_text = contentButtonText;
      }

      return trackingData;
    } catch (error) {
      console.error('Failed to parse tracking JSON:', error);
      return null;
    }
  }

  findClosestUrl(el) {
    if (!el) return null;

    if (el.tagName === "BUTTON") {
      return "add to cart";
    }

    if (el.hasAttribute?.('data-tracking-url')) {
      return el.getAttribute('data-tracking-url');
    } 

    if (el.querySelector?.('[data-tracking-url]')) { 
      return el.querySelector?.('[data-tracking-url]').getAttribute('data-tracking-url'); 
    }

    if (el.tagName === 'A' && el.href) { 
      return el.href; 
    }

    if (el.querySelector?.('a[href]')) { 
      return el.querySelector?.('a[href]').href; 
    }

    return null;
  }

  pushToDataLayerAndNavigate(data, url, originalEvent, targetElement) {
    if (!data) return;

    delete data.content_button_text;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);

    // FOR TESTING PURPOSES: Store the last tracking event in sessionStorage
    let event = JSON.parse(sessionStorage.getItem('lastTrackingEvent')) || [];
    event.push(data);
    sessionStorage.setItem('lastTrackingEvent', JSON.stringify(event));

    if (targetElement.tagName === 'A' && targetElement.href || targetElement.hasAttribute('data-tracking-url')) {
      if (url) {
        setTimeout(() => {
          if (originalEvent.ctrlKey || originalEvent.metaKey || originalEvent.shiftKey || originalEvent.button === 1) {
            window.open(url, '_blank');
          } else {
            window.location.href = url;
          }
        }, 100);
      }
    }
  }
}